<template>
  <div>
    <div class="sa-row sa-gutter10">
      <div class="sa-col-xs12 sa-col-sm6 sa-col-md10 sa-col-lg9">
        <h6>Referral Status</h6>
      </div>
      <div class="sa-col-xs12 sa-col-sm6 sa-col-md2 sa-col-lg3 sa-text-right sa-ref-picker">
        <div class="sa-form-group">
          <month-picker-input v-if="duration_month" :min-date="minDate" :default-month="duration_month" :default-year="duration_year" @input="showDate"></month-picker-input>
        </div>
      </div>
    </div>
    <div  v-if="refData">
      <div class="sa-row ref-det">
        <div class="sa-col-xs4 sa-col-sm14 sa-col-md4 sa-col-lg3">
          <div class="sa-card sa-card-border sa-card-noshadow ">
            <span ><strong class="sa-d-block">{{refData.upcoming}}</strong>Upcoming</span>
          </div>
        </div>
        <div class="sa-col-xs4 sa-col-sm14 sa-col-md4 sa-col-lg3">
          <div class="sa-card sa-card-border sa-card-noshadow ">
            <span ><strong class="sa-d-block">{{refData.pending}}</strong>Pending</span>
          </div>
        </div>
        <div class="sa-col-xs4 sa-col-sm14 sa-col-md4 sa-col-lg3">
          <div class="sa-card sa-card-border sa-card-noshadow ">
            <span><strong class="sa-d-block">{{refData.cancelled}}</strong>Cancelled</span>
          </div>
        </div>
        <div class="sa-col-xs4 sa-col-sm14 sa-col-md4 sa-col-lg3">
          <div class="sa-card sa-card-border sa-card-noshadow">
            <span><strong class="sa-d-block">{{refData.completed}}</strong>Completed</span>
          </div>
        </div>
        <div class="sa-col-xs4 sa-col-sm14 sa-col-md4 sa-col-lg3">
          <div class="sa-card sa-card-border sa-card-noshadow">
            <span><strong class="sa-d-block">{{refData.failed}}</strong>Failed</span>
          </div>
        </div>
      </div>
      <div class="sa-col-xs7 sa-col-sm6 sa-col-md10 sa-col-lg12">
        <h6>Referral Details</h6>
      </div>
      <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm12 sa-col-md6 sa-col-lg6 sa-pink-card">
          <div class="sa-card sa-card-border sa-card-noshadow sa-d-f-a-center">
            <i class="icon-total"></i
            ><span class="sa-ml20"
              >Expected Incentive
              <strong class="sa-d-block sa-black-text">{{refData.total_expected}}</strong></span
            >
          </div>
          <!-- <div class="sa-d-f-sbetween">
            <span class="sa-red-text">{{refData.pending}} more to complete</span>
          </div> -->
        </div>
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md7 sa-col-lg6">
            <div class="sa-row sa-ref-btn sa-mt30">
              <button class="sa-btn sa-btn-primary sa-btn-block-xs" @click="$parent.$emit('refRevenue', true)">
                View referral appointments
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { MonthPickerInput } from "vue-month-picker"
import { oh_url } from "../../../config/endpoints"
export default {
  components: {
    MonthPickerInput

  },
  data() {
    return {
      minDate: null,
      duration_month: null,
      duration_year: null,
      isHidden: false,
      refData: null,
    };
  },
  mounted() {
    let mdate = new Date()
    this.minDate = new Date('2021-12-01')
    this.duration_month = mdate.getMonth()+1
    this.duration_year = mdate.getFullYear()
    this.refferalDetails()
  },
  methods: {
    showDate (date) {
      this.duration_month = date.monthIndex
      this.duration_year = date.year
      this.refferalDetails()
    },
    refferalDetails() {
      let _self = this
       _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/referrals/details`,
          body: {
            duration_month: this.duration_month,
            duration_year: this.duration_year,
        }
        })
        .then((response) => {
          if(response && response.status == 1000){
            this.refData = response.data
          }
        })
    }
  }
};
</script>
<style>
svg.donut {
  overflow: visible;
  width: 50px;
}
.donutbg {
  fill: none;
  stroke: rgba(0, 0, 0, 0.05);
  stroke-width: 0.6;
}
.stroke {
  fill: none;
  stroke: #49bb00;
  stroke-width: 1;
  stroke-dasharray: 50 50;
  stroke-dashoffset: -51;
  stroke-linecap: round;
}
.donut text {
  font-size: 4px;
  font-weight: 600;
  text-anchor: middle;
  fill: #3d3d3d;
}
</style>
